import { FONT_SIZES, FONT_WEIGHTS, TYPOGRAPHY_COLORS } from '../globalTheme';
import { SIZE, WEIGHTS, FONT_TYPES, TYPOGRAPHY_COLOR_TYPES } from '../globalTypes';

const DISPLAY_TEXT_SIZE: Record<SIZE, string> = {
	xs: '24px',
	sm: '30px',
	md: '36px',
	lg: '48px',
	xl: '60px',
	xxl: '72px'
};

const DISPLAY_LINE_HEIGHT: Record<SIZE, string> = {
	xs: '32px',
	sm: '38px',
	md: '44px',
	lg: '60px',
	xl: '72px',
	xxl: '90px'
};

const DISPLAY_LETTER_SPACING: Record<SIZE, string> = {
	xs: '0em',
	sm: '0em',
	md: '-0.02em',
	lg: '-0.02em',
	xl: '-0.02em',
	xxl: '-0.02em'
};

const TEXT_LINE_HEIGHT: Record<SIZE, string> = {
	xs: '18px',
	sm: '20px',
	md: '24px',
	lg: '28px',
	xl: '30px',
	xxl: '32px'
};

export function getTypographyStyles(
	size: SIZE,
	weight: WEIGHTS,
	type: FONT_TYPES,
	color: TYPOGRAPHY_COLOR_TYPES
) {
	return {
		fontWeight: FONT_WEIGHTS[weight],
		fontSize: type === 'text' ? FONT_SIZES[size] : DISPLAY_TEXT_SIZE[size],
		lineHeight: type === 'text' ? TEXT_LINE_HEIGHT[size] : DISPLAY_LINE_HEIGHT[size],
		letterSpacing: type === 'text' ? '0em' : DISPLAY_LETTER_SPACING[size],
		color: TYPOGRAPHY_COLORS[color] || color
	};
}
